interface AboutSectionProps {
  professionalBio?: string | null;
}

export function AboutSection({ professionalBio }: AboutSectionProps) {
  if (!professionalBio) return null;

  return (
    <section>
      <div className="flex items-center gap-3 mb-4">
        <div className="h-5 w-1 rounded-full bg-gradient-to-b from-[hsl(237,52%,31%)] to-[hsl(237,52%,25%)]" />
        <h2 className="text-xl font-bold text-foreground">About Me</h2>
      </div>
      <div
        className="text-base text-foreground/80 leading-relaxed prose prose-base max-w-none"
        dangerouslySetInnerHTML={{ __html: professionalBio }}
      />
    </section>
  );
}
